import { Component, Input } from '@angular/core';
import { CommonInfoService } from '../cart-process/common-info.service';

@Component({
  selector: 'currency-symbol',
  templateUrl: './currency-symbol.component.html',
})
export class CurrencySymbolComponent {
  @Input() private unit: string;
  @Input() private mantissa: string;
  @Input() private oldPrice: boolean;

  constructor(
    public commonInfo: CommonInfoService
  ) {}

  public getCurrency() {
    if (!(this.unit && this.mantissa)) {
      return this.oldPrice ? 'zł' : this.commonInfo.priceEnding;
    };

    const rawMantissa = this.mantissa?.replace(',', '');
    const isPriceBiggerThanZero = parseFloat(this.unit) > 0 || (parseFloat(this.unit) === 0 && parseFloat(rawMantissa) > 0);
    
    return this.commonInfo.b2c ? 'zł' : (isPriceBiggerThanZero ? 'zł + VAT' : 'zł');
  }
}
